import { CognitoUser, CognitoUserSession } from "amazon-cognito-identity-js";
import { Auth } from "aws-amplify";

/**
 * Refreshes the current users JWT token using the
 * the refresh token from Amplify
 */
const refreshSession = async () => {
  const cognitoUser: CognitoUser = await Auth.currentAuthenticatedUser();
  const currentSession = await Auth.currentSession();

  return new Promise<CognitoUserSession>((resolve, reject) => {
    cognitoUser.refreshSession(
      currentSession.getRefreshToken(),
      (err: any, session: CognitoUserSession) => {
        if (err) {
          return reject(err);
        }

        return resolve(session);
      }
    );
  });
};

export default refreshSession;
